import { Grid, Typography } from "@mui/material";
import { TopUser } from "../../types/authTypes";
import defaultAvatarImg from "../../img/defaultProfile.jpg";
import ProfileImg from "../ProfileImg/ProfileImg";
import { COLLECTION_TAB } from "../../pages/MyProfile/MyProfile";
import { COLLECTION_SECTION } from "../../pages/MyProfile/Collection/Collection";
import LinkWrapper from "../LinkWrapper/LinkWrapper";

export interface CollectorCardProps {
  data: TopUser;
  count: number;
  countShow?: boolean;
  columnSize?: string;
}

/**
 * Collector card used for Top Collectors
 */
export const CollectorCard = ({
  data,
  count,
  countShow = true,
  columnSize = "col-xl-4 col-lg-6",
}: CollectorCardProps) => {
  const numberStyle = {
    fontWeight: 700,
    color: "#dfdfe2",
    fontSize: "1em",
  };

  const userNameStyle = {
    fontWeight: 700,
    color: "#3c3c40",
    fontSize: "1em",
  };

  const userTypeStyle = {
    fontWeight: 400,
    color: "#6f7d95",
    fontSize: "1em",
  };

  const shirtsStyle = {
    fontWeight: 700,
    color: "#ffffff",
    fontSize: "1em",
    backgroundColor: "#4663ff",
    paddingLeft: 1,
    paddingRight: 1,
    paddingTop: 1,
    paddingBottom: 1,
    borderRadius: 5,
    textAlign: "center",
    fontStyle: "italic",
  };

  return (
    <div className={columnSize}>
      <div className="seller-item">
        <div className="seller-inner">
          <Grid container direction="row" alignItems={"center"} minWidth={320}>
            {countShow && (
              <Grid item xs={1}>
                <Typography sx={numberStyle}>0{count + 1}</Typography>
              </Grid>
            )}
            <Grid item xs={2}>
              <LinkWrapper
                visitorUrl="/sign-up"
                freeUserUrl={
                  "/my-profile/" +
                  data.id +
                  "/" +
                  COLLECTION_TAB.COLLECTION +
                  "/" +
                  COLLECTION_SECTION.OVERVIEW
                }
                premiumUserUrl={
                  "/my-profile/" +
                  data.id +
                  "/" +
                  COLLECTION_TAB.COLLECTION +
                  "/" +
                  COLLECTION_SECTION.OVERVIEW
                }
                component={
                  <ProfileImg
                    imgUrl={
                      data.profile_image?.url
                        ? data.profile_image.url
                        : defaultAvatarImg
                    }
                    size={50}
                  />
                }
              />
            </Grid>
            <Grid
              item
              container
              direction="column"
              xs={6}
              sx={{ paddingLeft: "10px" }}
            >
              <Grid item>
                <LinkWrapper
                  visitorUrl="/sign-up"
                  freeUserUrl={
                    "/my-profile/" +
                    data.id +
                    "/" +
                    COLLECTION_TAB.COLLECTION +
                    "/" +
                    COLLECTION_SECTION.OVERVIEW
                  }
                  premiumUserUrl={
                    "/my-profile/" +
                    data.id +
                    "/" +
                    COLLECTION_TAB.COLLECTION +
                    "/" +
                    COLLECTION_SECTION.OVERVIEW
                  }
                  component={
                    <Typography sx={userNameStyle}>{data.username}</Typography>
                  }
                />
              </Grid>
              <Grid item>
                <Typography sx={userTypeStyle}>
                  {data.premium === true ? "Premium Collector" : "Collector"}
                </Typography>
              </Grid>
            </Grid>
            <Grid item xs={3}>
              <Typography sx={shirtsStyle}>{data.item_count} shirts</Typography>
            </Grid>
          </Grid>
        </div>
      </div>
    </div>
  );
};

export default CollectorCard;
